import { uploadFileService } from '@/api/services/files/filesService'
import { useMutation } from '@tanstack/react-query'
import { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'

export const useFilesHandler = () => {
  const [tmpLocation, setTmpLocation] = useState<string | null>(null)
  const [placeholderFiles, setPlaceholderFiles] = useState<File[]>([])

  const onDrop = useCallback((files: File[]) => {
    const renamedAcceptedFiles = files.map(
      (file: File) =>
        new File([file], file.name.replace(/ /g, '_'), {
          type: file.type
        })
    )
    setPlaceholderFiles((prev: File[]) => [...prev, ...renamedAcceptedFiles])
  }, [])

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    maxFiles: 1,
    multiple: false,
    noClick: true,
    accept: {
      'image/jpeg': [],
      'image/jpg': [],
      'image/png': [],
      'image/webp': [],
      'image/heic': [],
      'image/jfif': []
    },
    onDrop
  })

  const mutation = useMutation({
    mutationFn: (formData: FormData) => uploadFileService(formData)
  })

  useEffect(() => {
    if (placeholderFiles.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      handleSubmitFiles()
    }
  }, [placeholderFiles])

  const handleSubmitFiles = async () => {
    if (placeholderFiles.length === 0) return

    const formDatas: FormData[] = []
    let errorOccured = false

    placeholderFiles.forEach((file: File) => {
      const formData = new FormData()
      formData.append('file', file)
      formDatas.push(formData)
    })

    await Promise.all(
      formDatas.map(async (formData: FormData) => {
        if (errorOccured) return
        try {
          return await mutation.mutateAsync(formData, {
            onSuccess: (data) => {
              if (data.status !== 200) return setPlaceholderFiles([])
              setPlaceholderFiles([])
              const { location } = data.data as {
                location: string
              }
              setTmpLocation(location)
            }
          })
        } catch (error) {
          errorOccured = true
          setPlaceholderFiles([])
          console.error(error)
        }
      })
    )
  }

  // const handleToast = (title: string) => {
  //   setTimeout(() => {
  //     // toast.dismiss()
  //     // toast.toast({
  //     //   title: title
  //     // })
  //     // setTimeout(() => {
  //     //   toast.dismiss()
  //     // }, 3500)
  //   }, 1000)
  // }

  const handleDeletePlaceholderFiles = (index: number) => {
    const newFiles = placeholderFiles.filter((_, i: number) => i !== index)
    setPlaceholderFiles(newFiles)
  }

  return {
    getRootProps,
    getInputProps,
    isDragActive,
    open,
    handleDeletePlaceholderFiles,
    tmpLocation
  }
}
